import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Inputs } from '../verification-modal-styles';

const RadioContainer = styled.div`
  display: flex;
`;

const RadioLabel = styled.label`
  margin-left: 5px;
  font-size: 14px;
`;

function Radio(props) {
  const { label, value, checked, onClick } = props;

  return (
    <RadioContainer>
      <input
        type="radio"
        id={value}
        value={value}
        onClick={onClick}
        checked={checked}
      />
      <RadioLabel htmlFor={value}>{label}</RadioLabel>
    </RadioContainer>
  );
}

export const CORRECT_LISTING = 'CORRECT_LISTING';
export const INCORRECT_LISTING = 'INCORRECT_LISTING';

export function FlaggingActions(props) {
  const { allowUserToSelectAction, handleRadioSelect, flaggingAction } = props;

  if (!allowUserToSelectAction) return null;

  return (
    <Inputs>
      <Radio
        label="Correct APN/Address for this listing"
        value={CORRECT_LISTING}
        onClick={handleRadioSelect}
        checked={flaggingAction === CORRECT_LISTING}
      />

      <Radio
        label="The APN/Address listed is incorrect"
        value={INCORRECT_LISTING}
        onClick={handleRadioSelect}
        checked={flaggingAction === INCORRECT_LISTING}
      />
    </Inputs>
  );
}

FlaggingActions.propTypes = {
  allowUserToSelectAction: PropTypes.bool.isRequired,
  handleRadioSelect: PropTypes.func.isRequired,
  flaggingAction: PropTypes.string,
};
